import React from "react";
import "../Footer.css"; // Make sure this file handles spacing, color, etc.

function Footer() {
  return (
    <footer className="footer">
      <p>© {new Date().getFullYear()} PharmPrepPro. All rights reserved.</p>
      
      <p className="footer-disclaimer">
        NAPLEX®, MPJE®, and UMPJE® are federally registered trademarks of the National Association of Boards of Pharmacy. PharmPrepPro and its services are neither affiliated with nor endorsed by the NABP. None of the trademark holders is affiliated with, and does not endorse, PharmPrepPro.
        This site is protected by reCAPTCHA and the Google{" "}
        <a
          href="https://policies.google.com/privacy"
          target="_blank"
          rel="noopener noreferrer"
        >
          Privacy Policy
        </a>{" "}
        and{" "}
        <a
          href="https://policies.google.com/terms"
          target="_blank"
          rel="noopener noreferrer"
        >
          Terms of Service
        </a>{" "}
        apply.
      </p>
    </footer>
  );
}

export default Footer;
